import { connect } from 'react-redux';

import { getActiveScriptId, getSetPrimaryModal } from 'current/selectors';
import { closeSetPrimaryModal } from 'current/uiwidgets/';
import { setDisplayPrimaryScript } from 'scripts';

import SetPrimaryModal from './SetPrimaryModal';

export default connect(
  (state) => {
    return {
      setPrimaryModal: getSetPrimaryModal(state),
      scriptId: getActiveScriptId(state)
    };
  },
  (dispatch) => {
    return {
      onCancelSetPrimaryModal: () => {
        dispatch(closeSetPrimaryModal());
      },
      onSaveSetPrimaryModal: ({ scriptId }) => {
        dispatch(setDisplayPrimaryScript({ scriptId }));
      }
    };
  }
)(SetPrimaryModal);
